var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06726912,0.09585216 C1.42619627,0.09585216 0.09585216,1.42619627 0.09585216,3.06726912 C0.09585216,4.70834197 1.42619627,6.03868608 3.06726912,6.03868608 C4.70834197,6.03868608 6.03868608,4.70834197 6.03868608,3.06726912 C6.03868608,1.42619627 4.70834197,0.09585216 3.06726912,0.09585216 Z M4.02579072,3.06726912 C4.02579072,3.59579793 3.59579793,4.02579072 3.06726912,4.02579072 C2.53874031,4.02579072 2.10874752,3.59579793 2.10874752,3.06726912 C2.10874752,2.53874031 2.53874031,2.10874752 3.06726912,2.10874752 C3.59579793,2.10874752 4.02579072,2.53874031 4.02579072,3.06726912 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotCircle);
export default __webpack_public_path__ + "static/media/dot-circle.a3ae18077065d1dc408f2751bc394a33.svg";
export { ForwardRef as ReactComponent };